import axios from 'axios'
const API_URL = process.env.REACT_APP_BASEURL;
const Login_url = process.env.REACT_APP_LOGINURL;

const API = axios.create({ baseURL: Login_url});
export const logIn= (formData)=> API.post("login/" , formData);